import $ from 'jquery';
import Cookie from 'js-cookie';

function isAdmin() {
    return document.cookie.match(/admin=1/) !== null;
}

function canShowDisclaimer() {
    return Cookie.get('archive-disclaimer-shown') !== 'true';
}

function markShowDisclaimer(value) {
    Cookie.set('archive-disclaimer-shown', value.toString(), {path: '/'});
}

$('.js-archive-disclaimer').each((_, elem) => {
    if (!canShowDisclaimer()) {
        return;
    }
    const $elem = $(elem);
    const $close = $elem.find('.js-archive-disclaimer-close');

    $elem.removeClass('d-none');
    $close.on('click', ev => {
        ev.preventDefault();
        $elem.addClass('d-none');
        markShowDisclaimer('true');
    });

});
